var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.296,
    height: 22.729,
    viewBox: "0 0 26.296 22.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M587.457,289.317c0-1.119.008-2.19,0-3.261a.962.962,0,0,1,.55-1.03.951.951,0,0,1,1.082.3q4.645,4.23,9.293,8.455c.621.566.615,1.026-.018,1.6q-4.625,4.211-9.253,8.418a.966.966,0,0,1-1.127.308.982.982,0,0,1-.527-1.045c.012-1.089,0-2.178,0-3.358-.876,0-1.708-.026-2.538.005a15.19,15.19,0,0,0-5.931,1.3,7.833,7.833,0,0,0-4.6,5.666,2.634,2.634,0,0,1-.1.423.827.827,0,0,1-.894.573.78.78,0,0,1-.776-.72,19.263,19.263,0,0,1,1.482-9.34,12.968,12.968,0,0,1,5.31-6.129,16.527,16.527,0,0,1,7.544-2.131C587.092,289.348,587.237,289.335,587.457,289.317Zm1.75,12.021,7.442-6.766-7.442-6.765c0,.811,0,1.478,0,2.144,0,.825-.291,1.078-1.116,1.134a33.227,33.227,0,0,0-3.475.333c-6.258,1.1-9.265,5.792-10.017,10.729a2.775,2.775,0,0,0,.216-.192,10.165,10.165,0,0,1,3.629-2.566,20.164,20.164,0,0,1,9.75-1.335c.757.063,1.008.351,1.012,1.13C589.21,299.854,589.207,300.522,589.207,301.338Z",
    transform: "translate(-572.543 -284.953)",
    fill: "#2d335d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.dd0945e690792016947362f054055a5e.svg";
export { ForwardRef as ReactComponent };